import { createSlice } from '@reduxjs/toolkit';
import type { ProductDetail } from '@/features/pdp/domain/models/ProductDetail';

export const PDP_INITIAL_SLICE_NAME = 'pdpInitial';

export interface PdpInitialState {
  /** Product detail data from SSR; used so client does not refetch on hydration. */
  data: ProductDetail | null;
}

const initialState: PdpInitialState = {
  data: null,
};

const pdpInitialSlice = createSlice({
  name: PDP_INITIAL_SLICE_NAME,
  initialState,
  reducers: {
    setPdpInitialData(state, action: { payload: ProductDetail | null }) {
      state.data = action.payload ?? null;
    },
    clearPdpInitialData(state) {
      state.data = null;
    },
  },
});

export const pdpInitialReducer = pdpInitialSlice.reducer;
export const { setPdpInitialData, clearPdpInitialData } = pdpInitialSlice.actions;

/** Select initial PDP data from Redux (SSR-injected product data). */
export function selectPdpInitialData(state: { [PDP_INITIAL_SLICE_NAME]?: PdpInitialState }): ProductDetail | null {
  return state[PDP_INITIAL_SLICE_NAME]?.data ?? null;
}
